// icons.js
import {
  faNewspaper,
  faBook,
  faBoxesStacked,
  faHandshake,
  faGear,
} from "@fortawesome/free-solid-svg-icons";

const allTabs = [
  {
    id: "news",
    to: "/dashboard/news",
    tabIcon: faNewspaper,
  },
  {
    id: "references",
    to: "/dashboard/references",
    tabIcon: faBook,
  },
  {
    id: "products",
    to: "/dashboard/products",
    tabIcon: faBoxesStacked,
  },
  {
    id: "partners",
    to: "/dashboard/partners",
    tabIcon: faHandshake,
  },
  {
    id: "services",
    to: "/dashboard/services",
    tabIcon: faGear,
  },
];

export default allTabs;
